module.exports = __webpack_public_path__ + "img/bautenschutz-graffitientfernung.f029132.png";